export default "__VITE_ASSET__nlQysuOM__"